function linklist() {
  const link = [
    'https://youtube.com/shorts/MRz3qnmFjug?si=XYELOqLCmlXMVvlj', //フォニイ
    'https://youtube.com/shorts/BMtd9ObwJHM?si=ILhlr4SvbD0w4AMM', //Overdose
    'https://youtube.com/shorts/431zjRXNyb8?si=V8VRz8XrPShmtVqV', //可愛くてごめん
    'https://youtube.com/shorts/of_LrR8JxKw?si=-GrYjSmZ84FcfR4T', //残機
    'https://youtube.com/shorts/TELpb7gb4c0?si=o5CD90CIUt2uvBjX', //何にでも牛乳を注ぐ女
    'https://youtube.com/shorts/h2gUlj-mtnU?si=lwVb96YxDpwJ8XmT', //回る空うさぎ
    'https://youtube.com/shorts/T1nkqO_frio?si=WZEdcZHsCDs4Qt4l', //ガーネット
    'https://youtube.com/shorts/K_vV31Nrshw?si=u0kcPYgi3W0Ae_E6', //テレキャスタービーボーイ
    'https://youtube.com/shorts/-kaIHL6TpRI?si=V_1TsqrV99We_2dI', //斜陽
    'https://youtube.com/shorts/F_WuKrxZShU?si=MRO0I5SVu5Hnnr_f', //きゅうくらりん
    'https://youtube.com/shorts/e9l_1eUFmBA?si=Itu7BU494zjRnqW4', //Booo!
    'https://youtube.com/shorts/HOARFo2wGac?si=HVDugp3LZXIQXxzX', //三日月ステップ
    'https://youtube.com/shorts/dUBzd0XInoY?si=gWUbvQevAqd8wr8_', //私は、私達は
    'https://youtube.com/shorts/zf9ASc3CKjw?si=NiV7SjB8x8ovTPgR', //サインはB
    'https://youtube.com/shorts/j2ApY64BEWs?si=fEq6EjBRe6mLXh-Q', //ラビットホール
    'https://youtube.com/shorts/-_1BZbFQFxw?si=3LP8k2wO5V4g1692', //月のワルツ
    'https://youtube.com/shorts/WTtp0zlZfkc?si=4CrCnGAIoJcv4Ahy', //勇者
    'https://youtube.com/shorts/5I9mIhLnJt4?si=5tYK6Cy-n81SquOs', //猛独が襲う
    'https://youtube.com/shorts/_EI4x6N8udM?si=ESQjUwawjTQqJJnP', //撫でんな
    'https://youtube.com/shorts/zjr-4NCZ5pc?si=0l8Frh9-UpTFWFVn', //HappyHalloween
    'https://youtube.com/shorts/AfxUm7B0WIU?si=OfNCukK9isq339zZ', //カワキヲアメク
    'https://youtube.com/shorts/ZCK0GtU8n4I?si=NFP4co5NB21-6uHl', //クラクラ
    'https://youtube.com/shorts/D6bAdYRaQ-o?si=5rw8arbQzuigURAK', //キュートなカノジョ
  ]
  return link
}

export default linklist
